import { VersionCount } from '@frameio/shared/finder/components';
import { TextField } from '@frameio/vapor';
import { sanitizeAssetName } from '../../../utils/sanitizeAssetName';
import styles from './AssetNameRow.module.css';
import TEXT from './generated/TEXT/AssetNameRow';
import { SettingRow } from './SettingRow';

TEXT.DEFINE({
  /** Label for the asset name input field */
  name: 'Name',
});

export const AssetNameRow = ({
  onChange,
  value,
  versionNumber,
}: {
  /** Called with the sanitized name when the user types in the field. */
  onChange: (name: string) => void;
  /** Current asset name value. */
  value: string;
  /** When set, displays a version pill after the text field (e.g. "v2"). */
  versionNumber?: number | null;
}) => {
  return (
    <SettingRow
      field={
        <div className={styles.field}>
          <TextField
            adornmentAfter={
              versionNumber ? (
                <div data-testid="export-modal-version-pill">
                  <VersionCount compact={false} count={versionNumber} />
                </div>
              ) : undefined
            }
            hideLabel={true}
            label={TEXT.name}
            onChange={(e) => onChange(sanitizeAssetName(e.target.value))}
            value={value}
          />
        </div>
      }
      title={TEXT.name}
    />
  );
};
